import {listSvg as Icon__small__listSvg} from '../Icon__small/Icon__small--list.js'
import {listSvg as Icon__xsmall__listSvg} from '../Icon__xsmall/Icon__xsmall--list.js'

export var list = {
  name: 'list',
  category: 'icon',
  colorable: true,
  svg: Icon__small__listSvg,
  alt: {
    Icon__small: Icon__small__listSvg,
    Icon__xsmall: Icon__xsmall__listSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
